import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
// import createLogger from 'redux-logger';
import { browserHistory } from 'react-router';
import { routerMiddleware } from 'react-router-redux';
import { composeWithDevTools } from 'remote-redux-devtools';
import fetchMiddleware from '../middlewares/fetchMiddleware';
import tokenMiddleware from '../middlewares/tokenMiddleware';
import promiseMiddleware from '../middlewares/promiseMiddleware';

import rootReducer from '../reducers';

const router = routerMiddleware(browserHistory);

/**
 * Creates a preconfigured store.
 */
const configureStore = preloadedState => {
  let persistedState = {};
  try {
    persistedState = localStorage.getItem('reduxState') ? JSON.parse(localStorage.getItem('reduxState')) : {};
  } catch (e) {
    console.log('persistent failed', e);
  }

  const store = createStore(
    rootReducer,
    Object.assign(preloadedState || {}, { user: persistedState }),
    composeWithDevTools(
      applyMiddleware(promiseMiddleware, thunk, tokenMiddleware, fetchMiddleware, router),
    )
  );
  store.subscribe(() => {
    if (!store.getState().user.error) {
      const persistedStore = store.getState();
      if (persistedStore.user && persistedStore.user.isLoggedIn) {
        localStorage.setItem('reduxState', JSON.stringify(store.getState().user));
      }
    }
  });
  return store;
};


export default configureStore;
